import { render, staticRenderFns } from "./ImageUploadBox.vue?vue&type=template&id=16a0803a&scoped=true&"
import script from "./ImageUploadBox.vue?vue&type=script&lang=js&"
export * from "./ImageUploadBox.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadBox.vue?vue&type=style&index=0&id=16a0803a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a0803a",
  null
  
)

export default component.exports